import { GetterTree } from 'vuex';

import { RootState } from '@/store/types';

import { DaturaState } from './types';

const getters: GetterTree<DaturaState, RootState> = {};

export default getters;
